import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../Contexts/AuthenticateProvider";
import { useSocketPresence } from "../Contexts/SocketPresenceProvider";
import Layout from "../Layout";

function PrivateRoutes({ children }) {
    const { isAuthenticated } = useAuth();
    const location = useLocation();
    // reportPageChange is a stable (useCallback-memoised) reference from the
    // provider, so depending on it directly - rather than the whole context
    // object, which is a fresh literal on every provider render - keeps this
    // effect from re-firing on every online/away flip.
    const { reportPageChange } = useSocketPresence() || {};

    // Every private-route render (i.e. every navigation, since this
    // component sits above <Outlet/> for the whole admin panel) reports the
    // new route to the backend over the socket - satisfies "track the
    // admin's current page" without touching every individual page component.
    useEffect(() => {
        if (isAuthenticated) reportPageChange?.(location.pathname);
    }, [isAuthenticated, location.pathname, reportPageChange]);

    if (!isAuthenticated) {
        return <Navigate to="/" replace state={{ from: location.pathname }} />;
    }

    return (
        <Layout>
            {children}
            <Outlet />
        </Layout>
    );
}

export default PrivateRoutes;
